import { render, staticRenderFns } from "./SubAccountsControlBar.vue?vue&type=template&id=dda8f22c&scoped=true"
import script from "./SubAccountsControlBar.vue?vue&type=script&lang=js"
export * from "./SubAccountsControlBar.vue?vue&type=script&lang=js"
import style0 from "./SubAccountsControlBar.vue?vue&type=style&index=0&id=dda8f22c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda8f22c",
  null
  
)

export default component.exports